import { useState } from 'react'
import { useOutletContext } from 'react-router-dom'

import { FinanceValueObjectsDealStageEnum } from 'generated/resources/datatable.graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { DealCreateModal } from 'modules/finance/components/Deals/CreateModal'
import { DealsPipelineView } from 'modules/finance/components/Deals/DealsPipelineView'
import { SalesRootPageOutletContext } from 'modules/finance/pages/SalesRootPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DealsListPage = () => {
  const { routesVisibility: salesRootVisibility } = useOutletContext<SalesRootPageOutletContext>()
  const authorized = salesRootVisibility.finance._policies.sidebarSeeFinanceDealsSubLevelItem.can
  const {
    access: { locale },
  } = useCurrentSession()
  const [stage, setStage] = useState<FinanceValueObjectsDealStageEnum>()

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

  const handleDealCreated = () => {
    track(trackingEvents.accounting.deals.submitCreate, {
      source: 'sales_deals_list_page',
    })
  }

  const handleOpenModal = (stage?: FinanceValueObjectsDealStageEnum) => {
    setStage(stage)
    setIsCreateModalOpen(true)
    track(trackingEvents.accounting.deals.startCreate, { source: 'sales_deals_list_page' })
  }

  const handleCloseModal = () => {
    setIsCreateModalOpen(false)
  }

  useEffect(() => {
    track(trackingEvents.accounting.deals.viewDealsPage)
  }, [])

  return (
    <ResponsivePage.Body authorized={authorized} variant="full">
      <DealsPipelineView locale={locale} onClickCreateDeal={handleOpenModal} />

      <DealCreateModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseModal}
        refetchQuery="DealsPipelineView"
        stage={stage}
        onSuccess={handleDealCreated}
      />
    </ResponsivePage.Body>
  )
}

export default DealsListPage
